require("!!/home/selvam/projects/compare-my-religion/frontend/node_modules/script-loader/addScript.js")(require("!!/home/selvam/projects/compare-my-religion/frontend/node_modules/raw-loader/index.js!/home/selvam/projects/compare-my-religion/frontend/node_modules/chroma-js/chroma.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chroma-js/chroma.js
// module id = 387
// module chunks = 12